import { api_GET, api_POST, api_PUT } from './_api';

const tiposImplemento_api = {
    GetList: (status = "") => {
        const promise = new Promise((resolve, reject) => {
            api_GET(`TipoImplemento/GetList${status == "" ? "" : `/${status}`}`)
                .then(result => resolve(result))
                .catch(result => reject(result));
        });
        return promise;
    },
    GetItem: (id) => {
        const promise = new Promise((resolve, reject) => {
            api_GET(`TipoImplemento/GetItem/${id}`)
                .then(result => resolve(result))
                .catch(result => reject(result));
        });
        return promise;
    },
    GetModalidades: (id) => {
        const promise = new Promise((resolve, reject) => {
            api_GET(`TipoImplemento/GetModalidades/${id}`)
                .then(result => resolve(result))
                .catch(result => reject(result));
        });
        return promise;
    },
    Post: (obj) => {
        const promise = new Promise((resolve, reject) => {
            api_POST(`TipoImplemento`, obj)
                .then(result => resolve(result))
                .catch(result => reject(result));
        });
        return promise;
    },
    Put: (obj) => {
        const promise = new Promise((resolve, reject) => {
            api_PUT(`TipoImplemento`, obj)
                .then(result => resolve(result))
                .catch(result => reject(result));
        });
        return promise;
    },
}
export default tiposImplemento_api;